import React from 'react';
import { useReport } from '../../../contexts/ReportContext.jsx';
import ReportView from '../../../components/Report/ReportView';

const ReportStep = () => {
    const { reportData } = useReport();

    return <ReportView reportData={reportData} />;
};

export default ReportStep;